/**
 * Play a pause animation.
 */
export const showPauseAnimation = (): void => {
  const pauseElem: HTMLDivElement | null = document.querySelector('#preview-pause');
  if (!pauseElem) return;

  pauseElem.style.display = 'block';
  setTimeout(() => {
    pauseElem.style.display = 'none';
  }, 400);
};
